import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { formatAddress, formatNumber } from "utils/Functions"
import { querySmartContract } from "utils/RpcHelper"

export function LeaderboardPage() {
    const { burnAddress } = useParams()
    const [tokenAddress, setTokenAddress] = useState()
    const [tokenInfo, setTokenInfo] = useState<{ name: string, symbol: string }>()
    const [leaderboard, setLeaderboard] = useState<{ address: string, amount: string }[]>()

    const loadTokenAddress = async () => {
        const { token_address } = await querySmartContract(burnAddress!, { token_address: {} })
        setTokenAddress(token_address)
    }

    useEffect(() => {
        loadTokenAddress()
    }, [])

    const loadTokenInfo = async () => {
        const res = await querySmartContract(tokenAddress!, { token_info: {} })
        setTokenInfo(res)
    }

    useEffect(() => {
        if (tokenAddress) loadTokenInfo()
    }, [tokenAddress])

    const loadLeaderboard = async () => {
        let start_after = undefined;

        let leaderboardArr: { address: string, amount: string }[] = []
        while (true) {
            const { leaderboard } = await querySmartContract(burnAddress!, { leaderboard: { limit: 2, start_after } })
            leaderboardArr.push(...leaderboard)

            const { address: lastAddress } = leaderboardArr[leaderboardArr.length - 1] ?? { address: undefined }
            if (lastAddress == undefined || lastAddress == start_after) break;

            start_after = lastAddress;
        }

        setLeaderboard(leaderboardArr)
    }

    useEffect(() => {
        loadLeaderboard()
    }, [])

    return <div className="w-100 p-2 px-4">
        <h4>{tokenInfo?.symbol} Burn Leaderboard</h4>

        <div className="table-responsive">
            <table className="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Address</th>
                        <th>{tokenInfo?.symbol} Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        leaderboard?.map(
                            (e, i) => <tr>
                                <td>{i + 1}</td>
                                <td><span onClick={() => alert(e.address)} role="button" className="text-primary">{formatAddress(e.address)}</span></td>
                                <td><span onClick={() => alert(`${(Number(e.amount) ?? 0) / 1e6} ${tokenInfo?.symbol}`)} role="button" className="text-primary">{formatNumber((Number(e.amount) ?? 0) / 1e6)}</span></td>
                            </tr>
                        )
                    }

                </tbody>
            </table>
        </div>
    </div>
}